import { render } from "./LeadModal.vue?vue&type=template&id=60e6554d"
import script from "./LeadModal.vue?vue&type=script&lang=js"
export * from "./LeadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__